import { decoratorOptionValues } from './DecoratorOption.constants';

export const isDecoratorOption = value => decoratorOptionValues.includes(value);
